"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "civitella-paganico": {
    "4305d819": [{
      "hkey": "298d6bb1",
      "slug": "civitella-paganico",
      "name": "Civitella Paganico",
      "primary": true,
      "skipSearch": false
    }],
    "casenovole": [{
      "hkey": "298d6bb1",
      "slug": "civitella-paganico",
      "name": "Civitella Paganico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36bd6330": [{
      "hkey": "298d6bb1",
      "slug": "civitella-paganico",
      "name": "Civitella Paganico",
      "primary": true,
      "skipSearch": false
    }],
    "petriolo": [{
      "hkey": "298d6bb1",
      "slug": "civitella-paganico",
      "name": "Civitella Paganico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;